import type {
  Event as EventType,
  OutcomeWithId,
} from "hooks/firestore/betting/useBetting";
import React from "react";
import { useTitle } from "hooks/graphql/useTitles";
import { MatchCard } from "./MatchCard";
import { useSelections } from "hooks";

type BettingEventCardProps = {
  event: EventType;
  toggleSelection: (event: EventType, outcome: OutcomeWithId) => void;
  isSelected: boolean;
};

export const BettingEventCard = ({
  event,
  toggleSelection,
}: BettingEventCardProps) => {
  const title = useTitle(event.sport?.toLowerCase() ?? "");
  const {
    props: { selections },
  } = useSelections();

  if (!title || !event || event.eventType !== "MATCH") return null;

  return (
    <MatchCard
      event={event}
      title={title}
      onOutcomeClick={toggleSelection}
      selections={selections}
    />
  );
};
